const longformGallery = {
  key: 'longformGallery',
  componentKey: 'carousel',
  label: 'Longform Gallery'
};

export default longformGallery;
